module.exports = __webpack_public_path__ + "img/BQLogo2.6247a7f5.png";